<template>
  <article class="video-item" :class="[direction, { empty: !item }]" @click="watchMe">
    <div
      class="thumbnail"
      :class="{
        /*'col-4': direction == 'horizontal'*/
      }"
      v-if="item && item.snippet && item.snippet.thumbnails"
    >
      <img :src="item.snippet.thumbnails.maxres.url" v-if="direction != 'horizontal'" />
      <img :src="item.snippet.thumbnails.default.url" v-else />
      <div class="overlay">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M24 4C12.95 4 4 12.95 4 24C4 35.05 12.95 44 24 44C35.05 44 44 35.05 44 24C44 12.95 35.05 4 24 4ZM20 33V15L32 24L20 33Z" fill="#fff" />
        </svg>
      </div>
    </div>

    <div
      class="thumbnail"
      :class="{
        /*'col-4': direction == 'horizontal'*/
      }"
      v-else
    >
      <img src />
    </div>

    <div class="info" :class="{ 'col-8': direction == 'horizontal', 'mt-2': direction != 'horizontal' }">
      <template v-if="item">
        <h5 class="title typo-small" v-if="direction == 'horizontal'">{{ item.snippet.title }}</h5>
        <h5 class="title typo-title1" v-else>{{ item.snippet.title }}</h5>
      </template>
      <template v-else>
        <h5 class="title typo-title1"></h5>
      </template>
    </div>
  </article>
</template>

<script>
export default {
  name: "VideoItem",
  props: {
    item: Object,
    direction: {
      type: String,
      default: "column"
    }
  },
  methods: {
    watchMe() {
      if (this.item) this.$emit("watch", this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/core/themes/partials/_animation.scss";

$lineHeight: 1.3; //=> 1em + 0.3em

.video-item {
  display: flex;
  &:not(.empty) {
    cursor: pointer;
  }

  > .thumbnail {
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    background: $gradientGrey;
    img {
      width: 100%;
    }
    > .overlay {
      @include flex-center;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      color: #fff;
      background: linear-gradient(0deg, rgba(7, 40, 86, 0.7), rgba(7, 40, 86, 0.7));
      box-shadow: 0px 7px 20px rgba(0, 24, 46, 0.15);
      opacity: 0;
      @include trans-all;
    }
  }

  > .info {
    > .title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      // max-height: 5rem;

      line-height: $lineHeight;
      max-height: calc(#{$lineHeight} * 3em);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      -webkit-line-clamp: 3;
      @include trans-all;
    }
  }

  &.verticle {
    flex-direction: column;
    > .thumbnail {
      img {
        min-height: 220px;
      }
    }
  }

  &.horizontal {
    flex-direction: row;
    > .thumbnail {
      // img {
      //   // min-height: 90px;
      // }
    }
  }

  &:hover {
    > .thumbnail > .overlay {
      opacity: 1;
    }
    > .info > .title {
      color: $cPrimary;
    }
  }

  &.active {
    color: $cPrimary;
  }

  &.empty {
    > .thumbnail {
      img {
        @include skeleton("light");
      }
    }
    > .info > .title {
      width: 70%;
      @include skeleton("light") height: 16px;
    }
  }
}
</style>
